import type { ScreenModule } from "../../../app/screen-module";
import { ApprovalDetailPage } from "../ApprovalPages";

export default {
	id: "end-user.approval-detail",
	path: "/app/approvals/:approvalId",
	area: "end-user",
	label: "承認・差戻し詳細",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: ApprovalDetailPage,
} satisfies ScreenModule;
